import { render, staticRenderFns } from "./categoryChildren.vue?vue&type=template&id=48afef7e&scoped=true&"
import script from "./categoryChildren.vue?vue&type=script&lang=js&"
export * from "./categoryChildren.vue?vue&type=script&lang=js&"
import style0 from "./categoryChildren.vue?vue&type=style&index=0&id=48afef7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48afef7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48afef7e')) {
      api.createRecord('48afef7e', component.options)
    } else {
      api.reload('48afef7e', component.options)
    }
    module.hot.accept("./categoryChildren.vue?vue&type=template&id=48afef7e&scoped=true&", function () {
      api.rerender('48afef7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/categoryChildren.vue"
export default component.exports